import { render, staticRenderFns } from "./UserInputReport.vue?vue&type=template&id=10492349&scoped=true&"
import script from "./UserInputReport.vue?vue&type=script&lang=js&"
export * from "./UserInputReport.vue?vue&type=script&lang=js&"
import style0 from "./UserInputReport.vue?vue&type=style&index=0&id=10492349&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10492349",
  null
  
)

export default component.exports